<template>
  <div class="min-h-screen">
    <SegmentHero
      title="Política de Cookies"
      description="Entenda como usamos cookies e tecnologias semelhantes."
      title-class="text-white drop-shadow-md"
      primary-label=""
      primary-href=""
      secondary-label=""
      secondary-href=""
      disclaimer=""
      :background-image="heroBg"
      background-class="bg-center bg-cover bg-slate-900"
      overlay-variant="left"
    />

    <!-- Conteúdo -->
    <div class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl mx-auto">
          <p class="text-sm text-gray-400 mb-6">
            Última atualização: Julho de 2026 · Kali Sistemas · CNPJ 55.252.075/0001-51
          </p>

          <section class="space-y-12">
            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                O que são cookies?
              </h2>
              <p class="mt-3 text-gray-600">
                Como é prática comum em muitos sites profissionais, nós
                utilizamos cookies, que são pequenos arquivos baixados no seu
                dispositivo, para melhorar sua experiência de navegação. Esta
                página descreve quais informações os cookies coletam, como os
                utilizamos e por que às vezes precisamos armazená-los. Também
                explicamos como você pode impedir que esses cookies sejam
                armazenados — no entanto, isso pode impactar funcionalidades do
                site.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Como usamos os cookies?
              </h2>
              <p class="mt-3 text-gray-600">
                Utilizamos cookies por diversos motivos, detalhados abaixo. Em
                muitos casos, não existem opções padrão para desativar cookies
                sem desabilitar completamente funcionalidades e recursos
                adicionados ao site. É recomendável que você mantenha os cookies
                ativados caso não tenha certeza se precisa ou não deles, pois
                eles podem ser usados para fornecer serviços que você utiliza.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Desativar cookies
              </h2>
              <p class="mt-3 text-gray-600">
                Você pode impedir a configuração de cookies ajustando as
                configurações do seu navegador (consulte a seção de ajuda do
                navegador para saber como). Tenha em mente que a desativação de
                cookies afetará a funcionalidade deste e de muitos outros sites
                que você visita. Desativar cookies geralmente resultará na
                indisponibilidade de determinadas funcionalidades e recursos.
                Portanto, recomendamos que você não desative os cookies.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Cookies que definimos
              </h2>
              <p class="mt-3 text-gray-600">
                Estes são os cookies e itens de armazenamento local que o
                próprio site define, com o prazo de cada um:
              </p>
              <div class="mt-4 overflow-x-auto">
                <table class="w-full text-sm text-left text-gray-600 border border-gray-200 rounded-lg overflow-hidden">
                  <thead class="bg-gray-50 text-xs uppercase text-gray-500">
                    <tr>
                      <th class="px-4 py-2.5">Nome</th>
                      <th class="px-4 py-2.5">Finalidade</th>
                      <th class="px-4 py-2.5">Tipo</th>
                      <th class="px-4 py-2.5">Prazo</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100">
                    <tr>
                      <td class="px-4 py-2.5 font-mono text-xs">kali-cookie-consent</td>
                      <td class="px-4 py-2.5">Guarda sua decisão sobre cookies (aceitou/rejeitou)</td>
                      <td class="px-4 py-2.5">Necessário</td>
                      <td class="px-4 py-2.5">Até você mudar de decisão</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2.5 font-mono text-xs">kali-session</td>
                      <td class="px-4 py-2.5">Mantém sua sessão de navegação funcionando</td>
                      <td class="px-4 py-2.5">Necessário</td>
                      <td class="px-4 py-2.5">12 meses</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2.5 font-mono text-xs">kali-preferences</td>
                      <td class="px-4 py-2.5">Preferências gerais de navegação no site</td>
                      <td class="px-4 py-2.5">Funcionalidade</td>
                      <td class="px-4 py-2.5">12 meses</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2.5 font-mono text-xs">_ga, _gid, _gat</td>
                      <td class="px-4 py-2.5">Google Analytics — estatísticas de uso do site</td>
                      <td class="px-4 py-2.5">Analytics (só com aceite)</td>
                      <td class="px-4 py-2.5">Até 13 meses</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p class="mt-3 text-gray-600">
                Os cookies de analytics (Google Analytics/Tag Manager) só são
                carregados se você clicar em "Aceitar todos" ou marcar
                "Analytics" em "Personalizar", no banner de cookies. Se você
                rejeitar, fechar o banner sem decidir, ou deixar "Analytics"
                desmarcado na personalização, eles não são carregados. Você
                pode revisar ou trocar sua escolha a qualquer momento em
                "Gerenciar Cookies", no rodapé do site.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Cookies de Terceiros
              </h2>
              <p class="mt-3 text-gray-600">
                Em alguns casos especiais, também utilizamos cookies fornecidos
                por terceiros confiáveis. Por exemplo, usamos o Google
                Analytics, uma das soluções de análise mais difundidas e
                confiáveis da Web, para entender como você utiliza o site e como
                podemos melhorar sua experiência. Esses cookies podem rastrear
                itens como o tempo que você passa no site e as páginas
                visitadas, para que possamos continuar produzindo conteúdo
                relevante.
              </p>
              <p class="mt-3 text-gray-600">
                Análises de terceiros são usadas para medir o uso do site,
                permitindo melhorias contínuas. Periodicamente, testamos novos
                recursos e fazemos alterações sutis na apresentação do site;
                durante esses testes, cookies podem ser usados para garantir uma
                experiência consistente enquanto entendemos quais otimizações os
                usuários mais apreciam.
              </p>
              <p class="mt-3 text-gray-600">
                À medida que oferecemos produtos e serviços, é importante
                entendermos estatísticas sobre quantos visitantes realizam ações
                específicas (como preencher formulários). Esse tipo de dado
                ajuda a prever com precisão nossos custos e melhorias,
                garantindo o melhor serviço possível.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Mais informações
              </h2>
              <p class="mt-3 text-gray-600">
                Esperamos que estas informações tenham esclarecido as práticas
                de uso de cookies. Caso ainda tenha dúvidas, você pode falar com
                nosso Encarregado (DPO) pelo e-mail
                <a
                  href="mailto:privacidade@kalisistemas.com.br"
                  class="text-[#006086] font-semibold hover:underline"
                  >privacidade@kalisistemas.com.br</a
                >.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>

    <CTA />
  </div>
</template>

<script setup>
import CTA from "@/components/home/CTA.vue";
import SegmentHero from "@/components/ui/SegmentHero.vue";
import heroBg from "@/assets/privacy-bg.webp";
import { useSeo } from "@/composables/useSeo";

useSeo({
  title: "Política de Cookies | Kali Sistemas",
  description: "Entenda como usamos cookies e tecnologias semelhantes.",
  image: heroBg,
});
</script>
